var map = {
	"./VabAd/index.vue": "./src/layouts/components/VabAd/index.vue",
	"./VabAppMain/index.vue": "./src/layouts/components/VabAppMain/index.vue",
	"./VabAvatar/index.vue": "./src/layouts/components/VabAvatar/index.vue",
	"./VabBreadcrumb/index.vue": "./src/layouts/components/VabBreadcrumb/index.vue",
	"./VabDemand/index.vue": "./src/layouts/components/VabDemand/index.vue",
	"./VabLogo/index.vue": "./src/layouts/components/VabLogo/index.vue",
	"./VabNavBar/index.vue": "./src/layouts/components/VabNavBar/index.vue",
	"./VabRemind/index.vue": "./src/layouts/components/VabRemind/index.vue",
	"./VabThemeBar/index.vue": "./src/layouts/components/VabThemeBar/index.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/layouts/components sync recursive \\.vue$";